<div class="container-fluid mt-4">
    <div class="row">
        <div class="col-md-8">
            <div class="card mx-2 p-4">
                <div
                    *ngIf="!mostrarFormulario"
                    class="alert alert-success"
                    role="alert">
                    ¡Producto guardado exitosamente!
                    <div class="mt-3">
                        <button class="btn btn-success" (click)="showForm()">
                            Agregar más productos
                        </button>
                    </div>
                </div>

                <div *ngIf="mostrarFormulario">
                    <form (ngSubmit)="onSubmit()" #productoForm="ngForm">
                        <div class="mb-2 row">
                            <h5 class="card-title later-color">
                                Información del producto
                            </h5>
                        </div>

                        <div class="mb-3 row align-items-center">
                            <label
                                for="type-product"
                                class="col-sm-4 col-form-label">
                                Tipo de producto
                                <sup class="text-danger">*</sup>
                            </label>
                            <div class="col-sm-8">
                                <select
                                    class="form-select"
                                    id="type-product"
                                    [(ngModel)]="selectedTypeProduct"
                                    name="selectedProduct"
                                    (change)="onProductTypeChange()"
                                    required>
                                    <option
                                        value=""
                                        disabled
                                        selected
                                        class="grayed-text">
                                        Selecciona un tipo de producto
                                    </option>
                                    <option
                                        *ngFor="let option of optProductType"
                                        [value]="option.id">
                                        {{ option.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div
                                *ngIf="
                                    productoForm.submitted &&
                                    !productoForm.controls['selectedProduct']
                                        .valid
                                "
                                class="text-danger">
                                ¡Tipo producto requerido!
                            </div>
                        </div>

                        <div class="mb-3 row align-items-center">
                            <label
                                for="ica-number"
                                class="col-sm-4 col-form-label">
                                Número registro ICA
                                <sup class="text-danger">*</sup>
                            </label>
                            <div class="col-sm-8">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="ica-number"
                                    [(ngModel)]="icaNumber"
                                    name="icaNumber"
                                    required
                                    pattern="[A-Z0-9]+"
                                    maxlength="20" />
                            </div>
                            <div
                                *ngIf="
                                    productoForm.submitted &&
                                    !productoForm.controls['icaNumber'].valid
                                "
                                class="text-danger">
                                ¡Numero ICA requerido!
                            </div>
                            <div
                                *ngIf="
                                    productoForm.controls['icaNumber']?.dirty &&
                                    !productoForm.controls['icaNumber']?.valid
                                "
                                class="text-danger">
                                Sólo dígitos y letras mayúsculas, sin espacios
                                ni caracteres especiales
                            </div>
                        </div>

                        <div class="mb-3 row align-items-center">
                            <label
                                for="nombreComercial"
                                class="col-sm-4 col-form-label">
                                Nombre comercial del producto
                                <sup class="text-danger">*</sup>
                                <button
                                    type="button"
                                    class="btn btn-outline-success rounded-circle p-0 tooltip-icon-btn ms-1"
                                    (click)="mostrarTooltipNombreComercial()">
                                    <i class="fas fa-question"></i>
                                </button>
                            </label>
                            <div class="col-sm-8">
                                <input
                                    type="text"
                                    class="form-control text-uppercase"
                                    id="nombreComercial"
                                    [(ngModel)]="commercialName"
                                    name="commercialName"
                                    (ngModelChange)="
                                        commercialName = $event.toUpperCase()
                                    "
                                    required />
                            </div>
                            <div
                                *ngIf="
                                    productoForm.submitted &&
                                    !productoForm.controls['commercialName']
                                        .valid
                                "
                                class="text-danger">
                                ¡Nombre comercial requerido!
                            </div>
                        </div>

                        <div class="mb-3 row align-items-center">
                            <label
                                for="producer-company-name"
                                class="col-sm-4 col-form-label">
                                Nombre de la casa productora / Planta productora
                                <sup class="text-danger">*</sup>
                            </label>
                            <div class="col-sm-8">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="producer-company-name"
                                    [(ngModel)]="producerCompanyName"
                                    name="producerCompanyName"
                                    required />
                            </div>
                            <div
                                *ngIf="
                                    productoForm.submitted &&
                                    !productoForm.controls[
                                        'producerCompanyName'
                                    ].valid
                                "
                                class="text-danger">
                                ¡Nombre casa productora / Planta productora
                                requerido!
                            </div>
                        </div>

                        <div
                            class="mb-3 row align-items-center"
                            *ngIf="selectedTypeProduct !== '4'">
                            <label
                                for="product-origin1"
                                class="col-sm-4 col-form-label">
                                Origen del producto
                                <sup class="text-danger">*</sup>
                            </label>
                            <div class="col-sm-8">
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="productOrigin"
                                        id="productOrigin1"
                                        value="Producto Nacional"
                                        [(ngModel)]="origenDelProducto" />
                                    <label
                                        class="form-check-label"
                                        for="productOrigin1">
                                        Producto Nacional
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="productOrigin"
                                        id="productOrigin2"
                                        value="Producto importado"
                                        [(ngModel)]="origenDelProducto" />
                                    <label
                                        class="form-check-label"
                                        for="productOrigin2">
                                        Producto Importado
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="selectedTypeProduct === '1'">
                            <div
                                class="mb-3 row align-items-center"
                                *ngIf="
                                    origenDelProducto === 'Producto importado'
                                ">
                                <label class="col-sm-4 col-form-label">
                                    País de origen
                                </label>
                                <div class="col-sm-8">
                                    <ng-select
                                        [items]="countries"
                                        bindLabel="name"
                                        bindValue="name"
                                        [(ngModel)]="countryOrigin"
                                        placeholder="Selecciona un país"
                                        [searchable]="true"
                                        [clearable]="true"></ng-select>
                                </div>
                            </div>

                            <!-- Se ocultan los siguientes campos por logica de negocio - HU153 -->
                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="activeIngredient"
                                    class="col-sm-4 col-form-label">
                                    Ingrediente activo
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="activeIngredient"
                                        [(ngModel)]="activeIngredient"
                                        name="activeIngredient"
                                        required />
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="toxicologicalClassification"
                                    class="col-sm-4 col-form-label">
                                    Clasificación toxicológica
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="toxicologicalClassification"
                                        [(ngModel)]="
                                            toxicologicalClassification
                                        "
                                        name="toxicologicalClassification"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optToxicologicalClassification
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="productClassification"
                                    class="col-sm-4 col-form-label">
                                    Clasificación del producto
                                    <sup class="text-danger">*</sup>
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="productClassification"
                                        [(ngModel)]="productClassification"
                                        name="productClassification"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optProductClassification
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="formulationType"
                                    class="col-sm-4 col-form-label">
                                    Tipo de formulación
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="formulationType"
                                        [(ngModel)]="formulationTypeId"
                                        name="typeFormulation"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una formulación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optFormulationType
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="concentration"
                                    class="col-sm-4 col-form-label">
                                    Concentración
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="concentration"
                                        [(ngModel)]="concentration"
                                        name="concentration"
                                        required />
                                </div>
                            </div> -->
                        </div>

                        <div *ngIf="selectedTypeProduct === '2'">
                            <div
                                class="mb-3 row"
                                *ngIf="
                                    origenDelProducto === 'Producto importado'
                                ">
                                <label class="col-sm-4 col-form-label">
                                    País de origen
                                </label>
                                <div class="col-sm-8">
                                    <ng-select
                                        [items]="countries"
                                        bindLabel="name"
                                        bindValue="name"
                                        [(ngModel)]="fertiyCountryOrigin"
                                        placeholder="Selecciona un país"
                                        [searchable]="true"
                                        [clearable]="true"></ng-select>
                                </div>
                            </div>

                            <!-- Se ocultan los siguientes campos por logica de negocio - HU154 -->
                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="Classification1"
                                    class="col-sm-4 col-form-label">
                                    Clasificación 1, según el alcance de la
                                    reglamentación
                                    <sup class="text-danger">*</sup>
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="Classification1"
                                        [(ngModel)]="classification1"
                                        name="Classification1"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optClassification1
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="Classification2"
                                    class="col-sm-4 col-form-label">
                                    Clasificación 2, según el origen
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="Classification2"
                                        [(ngModel)]="classification2"
                                        name="Classification2"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optClassification2
                                            "
                                            [value]="option.nombre">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div
                                class="mb-3 row align-items-center"
                                *ngIf="classification2 === 'Inorgánico'">
                                <label
                                    for="Classification3"
                                    class="col-sm-4 col-form-label">
                                    Clasificación 3, según la composición
                                    garantizada NPK
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="Classification3"
                                        [(ngModel)]="classification3"
                                        name="Classification3"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optClassification3
                                            "
                                            [value]="option.nombre">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="fertiyTypeFormulation"
                                    class="col-sm-4 col-form-label">
                                    Tipo de formulación
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="fertiyTypeFormulation"
                                        [(ngModel)]="fertiyTypeFormulation"
                                        name="fertiyTypeFormulation"
                                        required />
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="fertiConcentration"
                                    class="col-sm-4 col-form-label">
                                    Concentración
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="fertiConcentration"
                                        [(ngModel)]="fertiConcentration"
                                        name="fertiConcentration"
                                        required />
                                </div>
                            </div> -->
                        </div>

                        <div *ngIf="selectedTypeProduct === '3'">
                            <div
                                class="mb-3 row"
                                *ngIf="
                                    origenDelProducto === 'Producto importado'
                                ">
                                <label class="col-sm-4 col-form-label">
                                    País de origen
                                </label>
                                <div class="col-sm-8">
                                    <ng-select
                                        [items]="countries"
                                        bindLabel="name"
                                        bindValue="name"
                                        [(ngModel)]="coadyuvanteCountryOrigin"
                                        placeholder="Selecciona un país"
                                        [searchable]="true"
                                        [clearable]="true"></ng-select>
                                </div>
                            </div>

                            <!-- Se ocultan los siguientes campos por logica de negocio - HU129 -->
                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="coadyuvanteClassification"
                                    class="col-sm-4 col-form-label">
                                    Clasificación del producto
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="coadyuvanteClassification"
                                        [(ngModel)]="coadyuvanteClassification"
                                        name="coadyuvanteClassification">
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una clasificación
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optProdClassCoad
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                            <!-- <div class="mb-3 row align-items-center">
                                <label
                                    for="ingredienteActivo"
                                    class="col-sm-4 col-form-label">
                                    Ingrediente activo
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="ingredienteActivo"
                                        [(ngModel)]="ingredienteActivo"
                                        name="ingredienteActivo" />
                                </div>
                            </div> -->
                        </div>

                        <div *ngIf="selectedTypeProduct === '4'">
                            <div class="mb-3 row align-items-center">
                                <label
                                    for="species-dropdown"
                                    class="col-sm-4 col-form-label">
                                    Especie
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="species-dropdown"
                                        [(ngModel)]="balanceFoodSpecie"
                                        name="specie-selected"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una especie
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optSpecieBalanceFood
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="mb-3 row align-items-center">
                                <label
                                    for="productive-stage-dropdown"
                                    class="col-sm-4 col-form-label">
                                    Etapa productiva
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="productive-stage-dropdown"
                                        [(ngModel)]="balanceFoodProductiveStage"
                                        name="specie-selected"
                                        required>
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona una etapa productiva
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optProductiveStage
                                            "
                                            [value]="option.nombre">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="selectedTypeProduct === '5'">
                            <div
                                class="mb-3 row"
                                *ngIf="
                                    origenDelProducto === 'Producto importado'
                                ">
                                <label class="col-sm-4 col-form-label">
                                    País de origen
                                </label>
                                <div class="col-sm-8">
                                    <ng-select
                                        [items]="countries"
                                        bindLabel="name"
                                        bindValue="name"
                                        [(ngModel)]="
                                            acondicionadorEnmiendaCountryOrigin
                                        "
                                        placeholder="Selecciona un país"
                                        [searchable]="true"
                                        [clearable]="true"></ng-select>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2 mt-5">
                            <div class="mb-4 row">
                                <h5 class="card-title later-color">
                                    Agregar presentación
                                </h5>
                            </div>

                            <div class="mb-3 row align-items-center">
                                <label
                                    for="dropdown1"
                                    class="col-sm-4 col-form-label">
                                    Empaque
                                    <sup class="text-danger">*</sup>
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="dropdown1"
                                        [(ngModel)]="selectedEmpaque"
                                        name="selectedEmpaque"
                                        (change)="onChangeEmpaque()"
                                        [disabled]="selectedTypeProduct === '4'"
                                        required>
                                        <option
                                            [ngValue]="null"
                                            disabled
                                            class="grayed-text">
                                            Selecciona empaque
                                        </option>
                                        <option
                                            *ngFor="let option of optPackaging"
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    *ngIf="
                                        productoForm.submitted &&
                                        !productoForm.controls[
                                            'selectedEmpaque'
                                        ].valid &&
                                        selectedTypeProduct !== '4'
                                    "
                                    class="text-danger">
                                    ¡Empaque requerido!
                                </div>
                            </div>

                            <div class="mb-3 row align-items-center">
                                <label
                                    for="dropdown2"
                                    class="col-sm-4 col-form-label">
                                    Unidad de medida equivalente
                                    <sup class="text-danger">*</sup>
                                </label>
                                <div class="col-sm-8">
                                    <select
                                        class="form-select"
                                        id="dropdown2"
                                        [(ngModel)]="selectedUnity"
                                        name="selectedUnity"
                                        [disabled]="selectedTypeProduct === '4'"
                                        required
                                        (change)="onChange($event)">
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona medida
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of optUnitsOfMeasurement
                                            "
                                            [value]="
                                                option.EmpaqueUnidadMedida.id
                                            "
                                            [attr.data-codigo]="option.codigo">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="mb-3 row align-items-center">
                                <label
                                    for="cantidad"
                                    class="col-sm-4 col-form-label">
                                    Cantidad (valor contenido por empaque)
                                    <sup class="text-danger">*</sup>
                                </label>
                                <div class="col-sm-8">
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="cantidad"
                                        name="quantity"
                                        [(ngModel)]="quantity"
                                        required
                                        min="0"
                                        step="0.1"
                                        [disabled]="selectedTypeProduct === '4'"
                                        (blur)="normalizeQuantity(1)" />
                                </div>
                                <div
                                    *ngIf="
                                        productoForm.submitted &&
                                        !productoForm.controls['quantity']
                                            .valid &&
                                        selectedTypeProduct !== '4'
                                    "
                                    class="text-danger">
                                    ¡Cantidad requerida!
                                </div>
                            </div>

                            <div class="mb-3 row align-items-center visibility">
                                <label
                                    for="dropdown2"
                                    class="col-sm-6 col-form-label">
                                    Unidad de presentación:
                                </label>
                                <div class="col-sm-6">
                                    <div class="d-flex align-items-center">
                                        <span>{{ selectedEmpaque }}</span>
                                        <span>
                                            {{
                                                quantity
                                                    ? padWithZeros(quantity)
                                                    : quantity
                                            }}
                                        </span>
                                        <span>{{ codigoSeleccionado }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            type="submit"
                            class="btn btn-success float-right">
                            Guardar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
